import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import IconSalesRepresentatives from 'components/icons/IconSalesRepresentatives';

const styles = () => ({
  root: {
    height: 330,
  },
  iconSalesRepresentatives: {
    width: 86,
    height: 104,
  },
  typographyBody: {
    textAlign: 'center',
    margin: '16px 16px 0 16px',
  },
});

const InventoryWarehousesTableEmpty = ({ classes }) => (
  <Grid
    className={classes.root}
    container
    direction="column"
    justify="center"
    alignItems="center"
    spacing={0}
  >
    <Grid item>
      <IconSalesRepresentatives className={classes.iconSalesRepresentatives} />
    </Grid>
    <Grid item>
      <Typography className={classes.typographyBody} variant="subheading" color="secondary">
        Unfortunately, there are no such inventory warehouse locations
      </Typography>
    </Grid>
  </Grid>
);

InventoryWarehousesTableEmpty.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    iconSalesRepresentatives: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(InventoryWarehousesTableEmpty);



// WEBPACK FOOTER //
// ./src/components/settings/InventoryWarehousesTable/InventoryWarehousesTableEmpty.js